<ngx-smart-modal #subscribe identifier="subscribe">
  <h2 class="modalError">Please subscribe to access this content.</h2>
  <a class="modalErrorButton" (click)="subscribe.close()" href="{{doi}}">Subscribe Now</a>
</ngx-smart-modal>
<ngx-smart-modal #myModal1 identifier="myModal1">
  <h2 class="modalError">Please login and subscribe to access this content.</h2>
  <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
</ngx-smart-modal>
 <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> -->
<div class="loadingBox" *ngIf="!loaded">
  <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
 </div>
   <div *ngIf="loaded">
<app-header></app-header>
<div id="wrapper">
    <app-sidebar></app-sidebar>
    <div class="single-channel-page" id="content-wrapper">
        <div class="single-channel-image">
            <img class="img-fluid" alt="" src={{playlist.imageUrl}}>
        </div>
        <div class="single-channel-nav">
                <nav class="navbar navbar-light bg-faded justify-content-between flex-nowrap flex-row">
                    <div class="container">
                        <p class="channel-brand" [class.active]="viewMode == 'tab1'">{{playlist.name}}
                            <span title="" data-placement="top" data-toggle="tooltip" data-original-title="Verified">
                                <i class="fas fa-check-circle text-success"></i>
                            </span>
                          </p>
                        <ul class="nav navbar-nav flex-row float-right flexNavBars">
                            <li class="nav-item">
                                <a (click)="updateRoute('videos')" class="nav-link" [class.active]="viewMode == 'videos'" rel="videos" (click)="viewMode ='videos'">All Videos</a>
                            </li>
                            <!-- <li class="nav-item">
                                <a i18n="@@About | About Playlist Button" (click)="updateRoute('about')" class="nav-link" [class.active]="viewMode == 'about'" rel="about" (click)="viewMode ='about'">About</a>
                            </li> -->
                            <li *ngIf="!singleChannelMultiPlay" class="nav-item">
                                <a i18n="@@Back to Channel | Back to Channel Button" class="nav-link" routerLink="/channel/{{playlist.channelID}}/explore">Back to Channel</a>
                            </li>
                            <li *ngIf="singleChannelMultiPlay" class="nav-item">
                              <a class="nav-link" routerLink="/">Back to Home</a>
                          </li>
                            <!-- <li class="nav-item dropdown no-arrow mx-1">
                                <a [class.active]="viewMode == 'search'" data-toggle="modal" data-target="#playlistSearch" title="Add to Favourites" class="nav-link"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-search fa-fw"></i>
                                    </a>
                            </li> -->
                        </ul>
                    </div>
                    </nav>
                
            </div>
            
        <div class="container-fluid">
                <div class="video-block section-padding">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="main-title">
                          
                            </div>
                        </div>
                       
                    <div class="tab-slider--container" [ngSwitch]="viewMode">
                        <div id="tab1" class="tab-slider--body" *ngSwitchCase="'videos'">
                                <div class="video-block section-padding">
                                        <div class="row">
                                          <div *ngIf="!videosLoaded" class="video-block section-padding loadingBlock container-fluid">
                                            <div id="loading"></div>
                                              </div>
                                            <div *ngFor="let video of contents; let i=index;" class="col-6 playlist col-sm-3 mb-3">
                                                <div class="video-card">
                                                    <div class="video-card-image" [class.educationImages]="isHeadStart">
                                                        <a class="play-icon" routerLink="/play/{{video.currentContentView}}">
                                                            <i class="fas fa-play-circle"></i>
                                                        </a>
                                                        <a routerLink="/play/{{video.currentContentView}}">
                                                            <span *ngIf="video.contentImageUrl != null"><img *ngIf="!isHeadStart" class="img-fluid" src="{{video.contentImageUrl}}" alt=""><img *ngIf="isHeadStart" class="img-fluid" src="{{video.contentImagePortraitUrl}}" alt=""></span><span *ngIf="video.contentImageUrl == null"><img *ngIf="!isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/content-default.png" alt=""><img *ngIf="isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/headstart.jpg" alt=""></span><span *ngIf="video.contentImagePortraitUrl== null"><img *ngIf="isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/headstart.jpg" alt=""></span>
                                                        </a>
                                                    </div>
                                                    <div class="video-card-body">
                                                        <div class="video-title">
                                                            <a routerLink="/play/{{video.currentContentView}}">{{video.title}}</a>
        
                                                        </div>
                                                        <div class="video-page text-success">
                                                            <a title="" data-placement="top" data-toggle="tooltip" routerLink="/play/{{video.currentContentView}}" data-original-title="Verified">
        
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                        </div>
                        <div id="tab2" class="tab-slider--body" *ngSwitchCase="'about'">
                            <div class="container">
                                <h2 i18n="@@About | About Title">About</h2>
                                <p>{{playlist.description}}</p>
                            </div>
                        </div>
                        <div id="tab3" class="tab-slider--body" *ngSwitchCase="'search'">
                            <div class="container">
                            <div *ngIf="searchResults == false">
                                <span i18n="@@No Results Found | No Search Results found Title">No results found</span>
                                </div>
                        <div *ngIf="searchResults != false">      
                        <div class="single-channel-nav">
                                <nav class="navbar navbar-expand-lg navbar-light">
                                  <span title="" data-placement="top" data-toggle="tooltip" data-original-title="Verified">
                                    <i class="fas fa-search text-success"></i>
                                  </span>
                                  <a i18n="@@Search Results | Single Channel Search Results Title" class="channel-brand m-3">Search Results
                          
                                  </a>
                                </nav>
                              </div>
                              <div class="video-block section-padding">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="main-title">
                                      <div class="row">
                                        <div *ngFor="let content of contentsSearch;" class="col-xl-3 col-6 col-sm-3 mb-3">
                                            <div class="video-card">
                                              <div class="video-card-image" [class.educationImages]="isHeadStart">
                                                <a class="play-icon" routerLink="/play/{{content.currentContentView}}">
                                                  <i class="fas fa-play-circle"></i>
                                                </a>
                                                <a routerLink="/play/{{content.currentContentView}}">
                                                  <a routerLink="/play/{{content.currentContentView}}"><span *ngIf="content.contentImageUrl != null"><img src="{{content.contentImageUrl}}" alt="{{content.title}} tag image"/></span><span *ngIf="content.contentImageUrl == null"><img src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/content-default.png" alt="{{content.title}} tag image"/></span></a>
                                                </a>
                                              </div>
                                              <div class="video-card-body">
                                                <div class="video-title">
                                                  <a routerLink="/play/{{content.currentContentView}}">{{content.title}}</a>
                                                </div>
                                                <div class="video-page text-success">
                                                  <a title="" data-placement="top" data-toggle="tooltip" routerLink="#" data-original-title="Verified">
                                                    
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                </div>


                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
            <!-- Sticky Footer -->
        </div>
    </div>
</div>
<div class="container-slider">
        <div class="navbarbottom">
          <a routerLink="/channel/{{playlist.channelID}}/explore"><i _ngcontent-c3="" class="fas fa-fw fa-arrow-left"></i> To Channel</a>
          <a routerLink="/my-list"><i _ngcontent-c3="" class="fas fa-fw fa-list"></i> <span class="myListFooterLink" i18n="@@Footer My List Link">My List</span></a>
        </div>
        </div>
        </div>
      <!-- add to favourites -->
    <div class="modal fade" id="playlistSearch" role="dialog">
        <div class="modal-dialog">
        
          <!-- Modal content-->
          <div class="modal-content">
                  <div class="modal-header">
                          <form (ngSubmit)='siteSearch()' class="d-md-inline-block form-inline">
                                  <div class="input-group">
                                      <input (keyup)="onSiteSearchKeyUp($event)" type="text" class="form-control" placeholder="Search for..." i18n-placeholder="From placeholder" value="" #searchInput>
                                      <div class="input-group-append">
                                              <a  class="btn btn-primary" (click)='siteSearch()'  data-dismiss="modal" data-target="#mobSearch"  title="Add to Favourites">Search Now <i class="fas fa-search"></i></a>
                                      </div>
                                  </div>
                              </form><a class="viewlist" data-dismiss="modal"><i _ngcontent-c3="" class="fas fa-fw fa-window-close"></i></a>
                  </div>
                  <div class="modal-body">
                         </div>
          </div>
          
        </div>
      </div>